
import {Vue, prop, Options} from "vue-class-component";
import levelingPartner from '@/app/infrastructures/misc/common-library/LevelingPartner';
import { SummarySTTData } from '@/domain/entities/PusatResolusiV2';
import { formatDateNormal } from '@/app/infrastructures/misc/Utils';
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import TrackingV2 from "@/app/ui/views/shipment/tracking-stt-cargo/tracking-stt-tab/v2/index.vue";
import { TrackingController } from '@/app/ui/controllers/TrackingController';
import { TrackingSttData, TrackingSttDetailData } from '@/domain/entities/TrackingStt';

class Props {
  isSummary = prop<boolean>({
    type: Boolean,
    default: false
  });
  detailData = prop<SummarySTTData>({
    type: SummarySTTData,
    required: true
  });
}

@Options({
  components: {
    TrackingV2
  }
})
export default class SummarySTT extends Vue.with(Props) {
  isShowTrackingModal = false;
  isCollapsed = false;

  get level() {
    return levelingPartner(this.detailData.posLevel)
  }

  get updatedAt() {
    return formatDate(this.detailData.updatedAt, "DD MMMM YYYY, HH:mm");
  }

  get bookingDate() {
    return formatDate(this.detailData.bookingDate, "DD MMMM YYYY, HH:mm");
  }

  get estimationDate() {
    return this.detailData.estimationDate ? formatDateNormal(this.detailData.estimationDate, "DD MMMM YYYY") : "-";
  }


  mapProductLogo(productCode: string) {
    const logoMap: any = {
      REGPACK: require("@/app/ui/assets/svg/product-logo/regpack-active.svg"),
      MINIPACK: require("@/app/ui/assets/svg/product-logo/minipack-active.svg"),
      BOSSPACK: require("@/app/ui/assets/svg/product-logo/bosspack-active.svg"),
      INTERPACK: require("@/app/ui/assets/svg/product-logo/interpack-active.svg"),
      JAGOPACK: require("@/app/ui/assets/svg/product-logo/jagopack-active.svg"),
      JUMBOPACK: require("@/app/ui/assets/svg/product-logo/jumbopack-active.svg"),
      JUMBOPACKH2H: require("@/app/ui/assets/svg/product-logo/jumbopackh2h-active.svg"),
      ONEPACK: require("@/app/ui/assets/svg/product-logo/onepack-active.svg"),
      OTOPACK150: require("@/app/ui/assets/svg/product-logo/otopack-150-active.svg"),
      OTOPACK250: require("@/app/ui/assets/svg/product-logo/otopack-250-active.svg"),
      SAMEDAY: require("@/app/ui/assets/svg/product-logo/sameday-active.svg"),
      BIGPACK: require("@/app/ui/assets/svg/product-logo/bigpack-active.svg"),
      BIGPACKFAST: require("@/app/ui/assets/svg/product-logo/bigpackfast-active.svg"),
      INTERPACKMAXI: require("@/app/ui/assets/svg/product-logo/interpackmaxi-active.svg"),
    };

    return logoMap[productCode] || null;
  }

  async onTrackingSTT() {
    await this.$router.replace({query: {'stt-no': this.detailData.sttNo}})
    TrackingController.setLoading(true);
    this.isShowTrackingModal = true;
  }

  async onCloseTrackingModal() {
    await this.$router.replace({query: {}})
    TrackingController.setTrackingSttData(new TrackingSttData(new TrackingSttDetailData(), []));
    TrackingController.setTrackingSttSecondData(new TrackingSttData(new TrackingSttDetailData(), []));
    this.isShowTrackingModal = false;
  }

  get showBadgeSLA() {
    const hideSLA = ["CLAIM", "CNX", "RTS", "RTSHQ", "REROUTE"]
    return !hideSLA.includes(this.detailData.lastStatus) && this.detailData.estimationDate;
  }
}
  
